export default "__VITE_ASSET__BM56Z$dl__"